import type { ReactNode } from "react";
import { RouterProvider } from "react-aria-components";
import { useHistory } from "react-router-dom";

export function AriaRouterProvider({ children }: { children: ReactNode }) {
  const history = useHistory();

  return <RouterProvider navigate={(path) => history.push(path)}>{children}</RouterProvider>;
}
